export default __webpack_public_path__ + "static/media/flower-loading-icon2.2315a20c.svg";